/* zd-cart.js - the zd cart drawer (sections/zd-cart-drawer.liquid). Phase 2 skeleton, Phase 3 AOV drawer.
   window.ZDCart:
     add(items, triggerEl)      POST /cart/add.js, swap drawer + header bubble HTML, open the drawer
     change(params, triggerEl)  POST /cart/change.js ({id: line key, quantity?, selling_plan?}), swap HTML
     open(triggerEl) / close() / refresh() / render(sectionsMap)
   All markup and every price come from Liquid (Section Rendering API: sections=zd-cart-drawer,cart-icon-bubble),
   so this file never computes money. Requests are queued one at a time so fast taps cannot race.
   Drawer controls (event delegation, survive re-renders):
     [data-zd-qty=plus|minus]  stepper (minus at 1 removes)      [data-zd-remove]  remove the line
     [data-zd-switch][data-plan] change the line's selling plan ("" = one-time)
     [data-zd-add][data-variant][data-qty][data-plan?][data-gifts?] add-on / empty-state quick add
     [data-zd-protect]         protection opt-in switch (add / set to 0)
     [data-zd-quick-add][data-variant][data-qty][data-plan?][data-gifts?] page cards outside the drawer (Phase 4/5); error slot
                               [data-zd-qa-err] inside the closest [data-zd-qa-card]
   Errors show inline (line: [data-zd-line-err], others: [data-zd-cart-err=...]) and leave the drawer as it was.
   Accessibility: focus moves into the panel on open, Tab is trapped inside, focus returns to the opener on close
   and to the same control (data-zd-fk) after every re-render; the page behind does not scroll.
   Events: zd:cart:before-open (cancelable, after a successful add; assets/zd-upsell.js shows the post-add offer),
   zd:cart:open / close / added / changed / rendered. */
(function () {
  'use strict';
  if (window.ZDCart) return;
  var SECTIONS = ['zd-cart-drawer', 'cart-icon-bubble'];
  var lastTrigger = null;
  var queue = Promise.resolve();

  function drawer() { return document.getElementById('ZdCartDrawer'); }
  function inner() { var d = drawer(); return d && d.querySelector('[data-zd-cart-inner]'); }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  // Sections render in the context of the current page (Shopify uses sections_url for that).
  function pageUrl() { return window.location.pathname + window.location.search; }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains('is-open')); }

  function swap(html, selector, target) {
    if (!html || !target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(selector);
    if (src) target.innerHTML = src.innerHTML;
    return src;
  }
  function render(sections) {
    if (!sections) return;
    var d = drawer();
    var box = inner();
    if (d && box && sections['zd-cart-drawer']) {
      var active = document.activeElement;
      var fk = active && box.contains(active) && active.getAttribute('data-zd-fk');
      var body = box.querySelector('[data-zd-cart-body]');
      var scroll = body ? body.scrollTop : 0;
      var src = swap(sections['zd-cart-drawer'], '[data-zd-cart-inner]', box);
      if (src) {
        // Oct 14: also sync the auto-add flags, so protection and the towels gift go in once per cart, not on every add.
        ['data-item-count', 'data-zd-orphan', 'data-zd-prot-auto', 'data-zd-gift-variant', 'data-zd-gift-min', 'data-zd-gift-code'].forEach(function (a) {
          if (src.hasAttribute(a)) box.setAttribute(a, src.getAttribute(a)); else box.removeAttribute(a);
        });
      }
      var nb = box.querySelector('[data-zd-cart-body]');
      if (nb) nb.scrollTop = scroll;
      if (isOpen() && active && !document.body.contains(active)) {
        var again = fk && box.querySelector('[data-zd-fk="' + fk + '"]');
        var target = again || box.querySelector('[data-zd-cart-close]') || d.querySelector('[data-zd-cart-panel]');
        if (target) target.focus({ preventScroll: true });
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) swap(sections['cart-icon-bubble'], '.shopify-section', bubble);
    reserve();
    document.dispatchEvent(new CustomEvent('zd:cart:rendered', { detail: { sections: sections } }));
  }

  /* ---------- "Your order is reserved for mm:ss" (informational; clock kept for the browser session) ---------- */
  var RKEY = 'zd_cart_reserved_until', rTimer = null;
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function reserve() {
    var bar = drawer() && drawer().querySelector('[data-zd-reserve]');
    if (!bar) return;
    var end = +ss(RKEY);
    if (!end && isOpen()) { end = Date.now() + (+bar.getAttribute('data-minutes') || 10) * 60000; ss(RKEY, String(end)); }
    if (!end) return;
    var clock = bar.querySelector('[data-zd-reserve-clock]');
    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    if (left <= 0) { bar.hidden = true; return; }
    if (clock) clock.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    if (!rTimer) rTimer = setInterval(reserve, 1000);
  }

  /* ---------- open / close, focus trap, scroll lock ---------- */
  function open(trigger) {
    var d = drawer();
    if (!d) return;
    if (!isOpen()) lastTrigger = trigger || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('zd-cart-open');
    var x = d.querySelector('.zd-cart__x');
    reserve();
    setTimeout(function () { if (x && isOpen()) x.focus({ preventScroll: true }); }, 50);
    document.dispatchEvent(new CustomEvent('zd:cart:open'));
  }
  function close() {
    var d = drawer();
    if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('zd-cart-open');
    if (lastTrigger && lastTrigger.focus && document.body.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    lastTrigger = null;
    document.dispatchEvent(new CustomEvent('zd:cart:close'));
  }
  function focusables() {
    var p = drawer() && drawer().querySelector('[data-zd-cart-panel]');
    if (!p) return [];
    return Array.prototype.filter.call(
      p.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; }
    );
  }

  /* ---------- requests ---------- */
  function post(path, payload) {
    payload.sections = SECTIONS.join(',');
    payload.sections_url = pageUrl();
    return fetch(rootUrl() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error((j && (j.description || j.message)) || 'Something went wrong. Please try again.');
          e.response = j;
          throw e;
        }
        return j;
      });
    }).then(function (j) {
      if (j.sections) render(j.sections);
      else return refresh().then(function () { return j; });
      return j;
    });
  }
  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }
  function refresh() {
    var u = pageUrl();
    u += (u.indexOf('?') > -1 ? '&' : '?') + 'sections=' + SECTIONS.join(',');
    return fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .then(cleanOrphan);
  }
  // Protection on its own is not an order: when every product line is gone, take it out too.
  // Round 9j: also a free gift line (towels) whose qualifying roll is gone. data-zd-orphan = space-separated line keys.
  function cleanOrphan() {
    var box = inner();
    var keys = ((box && box.getAttribute('data-zd-orphan')) || '').split(' ').filter(Boolean);
    if (!keys.length) return;
    box.removeAttribute('data-zd-orphan');
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return post('cart/update.js', { updates: updates });
  }
  // Round 9j (Mando Oct 6): lines that ride along with a shopper's add.
  //  - Free returns + package protection, on by default (drawer data-zd-prot-auto) unless they turned it off this visit.
  //  - The free towels gift line when the add includes a tier that unlocks it (data-zd-gift-*), plus its discount code.
  function protOff() { try { return sessionStorage.getItem('zd_prot_off') === '1'; } catch (e) { return false; } }
  function extras(items) {
    var box = inner(), out = { items: [], code: '' };
    if (!box) return out;
    var pv = +box.getAttribute('data-zd-prot-auto') || 0;
    if (pv && !protOff() && items.some(function (i) { return +i.id !== pv; })) out.items.push({ id: pv, quantity: 1 });
    var gv = +box.getAttribute('data-zd-gift-variant') || 0, gmin = +box.getAttribute('data-zd-gift-min') || 3;
    if (gv && items.some(function (i) { return i.properties && +i.properties._zd_gifts >= gmin; })) {
      out.items.push({ id: gv, quantity: 1, properties: { _zd_free_gift: 'towels' } });
      out.code = box.getAttribute('data-zd-gift-code') || '';
    }
    return out;
  }
  function add(items, trigger) {
    var x = extras(items);
    return (x.code ? applyCode(x.code) : Promise.resolve()).then(function () {
      return enqueue(function () {
        return post('cart/add.js', { items: items.concat(x.items) });
      });
    }).then(function (j) {
      // Newly added lines are first: show them (a re-render otherwise keeps the scroll position).
      var box = inner(), body = box && box.querySelector('[data-zd-cart-body]');
      if (body) body.scrollTop = 0;
      // Hook for the post add-to-cart offer (assets/zd-upsell.js): a listener may call preventDefault() to show
      // its own screen first; it opens the drawer itself afterwards.
      var before = new CustomEvent('zd:cart:before-open', { cancelable: true, detail: { items: items, response: j, trigger: trigger, drawerOpen: isOpen() } });
      if (document.dispatchEvent(before) || isOpen()) open(trigger);
      document.dispatchEvent(new CustomEvent('zd:cart:added', { detail: { items: items, response: j } }));
      return j;
    });
  }
  function change(params, trigger) {
    return enqueue(function () {
      return post('cart/change.js', params).then(function (j) { return Promise.resolve(cleanOrphan()).then(function () { return j; }); });
    }).then(function (j) {
      document.dispatchEvent(new CustomEvent('zd:cart:changed', { detail: { params: params, response: j } }));
      return j;
    });
  }

  // Tier gifts (data-gifts = how many gift-ladder rungs the tier unlocks) ride on the line as the hidden property
  // _zd_gifts, like the product page's add, so the drawer's gift ladder agrees with the card / buy box (08-02).
  function gifts(el, item) {
    var g = +el.getAttribute('data-gifts') || 0;
    if (g > 0) item.properties = { _zd_gifts: String(g) };
    if (g >= 2) item.properties['_Free gift'] = 'Mystery gift'; // shows on the order for packing
    var tier = el.getAttribute('data-tier');
    if (tier) { item.properties = item.properties || {}; item.properties._zd_tier = tier; }
  }

  /* ---------- drawer controls ---------- */
  function showError(slot, msg) {
    if (!slot) return;
    slot.textContent = msg;
    slot.hidden = false;
  }
  function busy(el, on) {
    var box = inner();
    if (box) box.classList.toggle('is-busy', on);
    if (el) { el.disabled = on; if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy'); }
  }
  function run(el, promise, errSlot) {
    busy(el, true);
    return promise.catch(function (e) {
      showError(errSlot, (e && e.message) || 'Something went wrong. Please try again.');
    }).then(function () { busy(el, false); });
  }
  function lineAction(t) {
    var line = t.closest('[data-zd-cart-line]');
    if (!line) return false;
    var key = line.getAttribute('data-key');
    var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
    var err = line.querySelector('[data-zd-line-err]');
    if (err) err.hidden = true;
    var step = t.closest('[data-zd-qty]');
    if (step) {
      var q = step.getAttribute('data-zd-qty') === 'plus' ? qty + 1 : qty - 1;
      run(step, change({ id: key, quantity: Math.max(0, q) }, step), err);
      return true;
    }
    var rm = t.closest('[data-zd-remove]');
    if (rm) { run(rm, change({ id: key, quantity: 0 }, rm), err); return true; }
    var sw = t.closest('[data-zd-switch]');
    if (sw) {
      var plan = sw.getAttribute('data-plan');
      run(sw, change({ id: key, quantity: qty, selling_plan: plan ? +plan : null }, sw), err);
      return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-zd-cart-close]')) { e.preventDefault(); close(); return; }
    var d = drawer();
    // Quick add on page cards (homepage bestsellers, Phase 4; collection cards, Phase 5): same add as the
    // product page, opens the drawer, URL unchanged. Error shows in the card's [data-zd-qa-err].
    var qa = t.closest('[data-zd-quick-add]');
    if (qa && !(d && d.contains(qa))) {
      e.preventDefault();
      var qi = { id: +qa.getAttribute('data-variant'), quantity: +qa.getAttribute('data-qty') || 1 };
      if (qa.getAttribute('data-plan')) qi.selling_plan = +qa.getAttribute('data-plan');
      gifts(qa, qi);
      var card = qa.closest('[data-zd-qa-card]');
      var qerr = card && card.querySelector('[data-zd-qa-err]');
      if (qerr) qerr.hidden = true;
      run(qa, applyCode(qa.getAttribute('data-code')).then(function () { return add([qi], qa); }), qerr);
      return;
    }
    if (d && d.contains(t)) {
      if (lineAction(t)) { e.preventDefault(); return; }
      var a = t.closest('[data-zd-add]');
      if (a) {
        e.preventDefault();
        var item = { id: +a.getAttribute('data-variant'), quantity: +a.getAttribute('data-qty') || 1 };
        if (a.getAttribute('data-plan')) item.selling_plan = +a.getAttribute('data-plan');
        gifts(a, item);
        var slot = d.querySelector(a.closest('[data-zd-bestsellers]') ? '[data-zd-cart-err="bestsellers"]' : '[data-zd-cart-err="addons"]');
        if (slot) slot.hidden = true;
        run(a, applyCode(a.getAttribute('data-code')).then(function () { return add([item], lastTrigger); }), slot);
        return;
      }
      return;
    }
    var icon = t.closest('#cart-icon-bubble, a.header__icon--cart');
    if (icon && d) {
      e.preventDefault();
      refresh().catch(function () {}).then(function () { open(icon); });
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-zd-protect]')) return;
    var d = drawer();
    var slot = d && d.querySelector('[data-zd-cart-err="protect"]');
    if (slot) slot.hidden = true;
    var p;
    try { if (t.checked) sessionStorage.removeItem('zd_prot_off'); else sessionStorage.setItem('zd_prot_off', '1'); } catch (err) {}
    if (t.checked) p = enqueue(function () { return post('cart/add.js', { items: [{ id: +t.getAttribute('data-variant'), quantity: 1 }] }); });
    else p = change({ id: t.getAttribute('data-key') || t.getAttribute('data-variant'), quantity: 0 }, t);
    run(t, p.catch(function (err) { t.checked = !t.checked; throw err; }), slot);
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    var panel = drawer().querySelector('[data-zd-cart-panel]');
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });

  // Round 8 (Mando Oct 6): sale add-ons carry a real Shopify discount code (data-code). It is added to the cart's codes
  // (kept alongside any code already there, e.g. ROUTINE50) through /cart/update.js before the add, so the drawer
  // shows the discounted price the card showed. Falls back to GET /discount/CODE if the cart refuses the update.
  function applyCode(code) {
    code = (code || '').trim();
    if (!code) return Promise.resolve();
    return enqueue(function () {
      return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var have = ((c && c.discount_codes) || []).map(function (d) { return d.code; });
          if (have.some(function (h) { return h.toUpperCase() === code.toUpperCase(); })) return null;
          return fetch(rootUrl() + 'cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: have.concat(code).join(',') })
          }).then(function (r) { if (!r.ok) throw new Error('update'); });
        })
        .catch(function () { return fetch(rootUrl() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {}); });
    });
  }
  // One ticker for every sale clock ([data-zd-sale-clock]), including ones re-rendered inside the drawer.
  setInterval(function () {
    var cd = window.ZDCountdown;
    if (!cd) return;
    var els = document.querySelectorAll('[data-zd-sale-clock]');
    for (var i = 0; i < els.length; i++) {
      var n = Date.now(), m = els[i].getAttribute('data-zd-timer') || cd.DEFAULT_MODE;
      els[i].textContent = cd.format(cd.nextEnd(m, n) - n);
    }
  }, 1000);

  window.ZDCart = { applyCode: applyCode, add: add, change: change, open: open, close: close, refresh: refresh, render: render, isOpen: isOpen, sections: SECTIONS };
})();
